// Authentication utility functions

export const getToken = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("token");
  }
  return null;
};

export const setToken = (token) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("token", token);
  }
};

export const removeToken = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("token");
  }
};

export const getUser = () => {
  if (typeof window !== "undefined") {
    const userStr = localStorage.getItem("user");
    return userStr ? JSON.parse(userStr) : null;
  }
  return null;
};

export const setUser = (user) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("user", JSON.stringify(user));
    // Dispatch custom event for real-time updates
    window.dispatchEvent(new CustomEvent('userDataUpdated'));
  }
};

export const removeUser = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("user");
  }
};

export const signOut = () => {
  removeToken();
  removeUser();
  removeCompany();
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const setCompany = (company) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("company", JSON.stringify(company));
    // Dispatch custom event for real-time updates
    window.dispatchEvent(new CustomEvent('userDataUpdated'));
  }
};

export const getCompany = () => {
  if (typeof window !== "undefined") {
    const companyStr = localStorage.getItem("company");
    return companyStr ? JSON.parse(companyStr) : null;
  }
  return null;
};

export const removeCompany = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("company");
  }
};

export const isAdmin = () => {
  if (typeof window !== "undefined") {
    const company = getCompany();
    
    // Check if company has is_admin property
    if (company && company.is_admin !== undefined) {
      return company.is_admin;
    }
    
    // Default to false if no admin status is found
    return false;
  }
  return false;
}; 